import { createContext, useReducer } from 'react'
import { type FightProviderProps, type FightDataContextProps, type FightDispatchContextProps, type Fight } from 'src/types'

import { reducer } from './reducer'
import { fights as fightsBackup } from 'src/data'

/* TEMP */
const fightData: Record<string, Fight> = {}

fightsBackup.forEach((entry) => {
  fightData[entry.id] = entry
})

export const FightDataContext = createContext<FightDataContextProps>({ fights: fightData })
FightDataContext.displayName = 'FightDataContext'

export const FightDispatchContext = createContext<FightDispatchContextProps>({ dispatchFights: () => null })
FightDispatchContext.displayName = 'FightDispatchContext'

export const FightProvider = ({ children }: FightProviderProps) => {
  const [fights, dispatchFights] = useReducer(reducer, fightData)
  
  return (
    <FightDataContext.Provider value={{ fights }}>
      <FightDispatchContext.Provider value={{ dispatchFights }}>
        {children}
      </FightDispatchContext.Provider>
    </FightDataContext.Provider>
  )
}
